import React, { Suspense } from 'react';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';

const DelayedSupportMenu = withPageReadyAsync(() =>
  import(/* webpackChunkName: "support-menu.async" */ './support-menu-with-i18n').then(({ SupportMenuWithI18n }) => ({
    default: SupportMenuWithI18n,
  })));

export const SupportMenu = () => (
  <Suspense fallback={<div />}>
    <DelayedSupportMenu />
  </Suspense>
);
